__turbopack_context__.v({
  "description": "FcT5Dq_description",
  "label": "FcT5Dq_label",
});
